import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env'
import makeAjaxRequest from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest'

const ERROR_KEYS = {
  400: {
    key: 'common.error.unknown',
  },
  422: {
    key: 'common.error.unknown',
  },
  default: {
    key: 'common.error.unknown',
  },
}

const getPayload = ({ captchaResponseToken, email }) => {
  const payload = {
    account: {
      captcha: {
        token: captchaResponseToken,
      },
      email,
    },
  }
  return payload
}

export default (properties) =>
  makeAjaxRequest({
    errorKeys: ERROR_KEYS,
    payload: getPayload(properties),
    url: `${APIGATEWAY_BASE_URL}/v5/${properties.locale}/passwords/reset`,
    verb: 'POST',
  })
    .then((response) => response)
    .catch((error) => error)

export { ERROR_KEYS }
